// extracted by mini-css-extract-plugin
module.exports = {"withOnClickHandler":"_2S73V","filter-effect-svg":"_2Ea4I","filterEffectSvg":"_2Ea4I"};